<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ L.localize('Settings_Breadcrumb_Billing') }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <div class="form js-form">
          <submenu></submenu>
          <div class="options-list">
            <div class="options-list__item">
              <div class="options-list__content">
                <h2 class="options-list__title">Stripe</h2>
                <h6 class="options-list__subtitle">{{ L.localize('Label_Stripe_Description') }}</h6>
              </div>
              <div class="options-list__control">
                <a href="javascript: void(0)" class="button button--border" @click="unlink" data-acc="toggle" v-if="tenant.stripe.connected">
                  {{ L.localize('Label_Unlink') }}
                </a>
                <a :href="tenant.stripe.endpoint" class="button button--border" data-acc="toggle" v-else>
                  {{ L.localize('Settings_Breadcrumb_Billing_Button') }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>

  </article>
</template>

<script>
import { CheckBox } from 'components/layout/forms'
import Submenu from 'components/views/membership/Submenu'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import notifications from 'mixins/notifications'

export default {
  name: 'payment-gateways',
  components: { Submenu, CheckBox },
  mixins: [notifications],
  data() {
    return {
      L: L
    }
  },
  beforeCreate() {
    let code = this.$route.query.code
    if (code) {
      this.$store.dispatch('linkStripe', code).then(() => {
        // we want to remove 'code' query from URL
        this.$router.push({ name: 'payment-gateways' })
        this.showNotification({
          title: L.localize('Label_SuccessEdit'),
          message: L.localize('Label_Success')
        })
      })
    } else {
      this.$store.dispatch('getTenantSession')
    }
  },
  computed: {
    ...mapGetters({
      tenant: 'getCurrentTenant'
    })
  },
  methods: {
    unlink() {
      this.$store.dispatch('unlinkStripe').then(() => {
        this.showNotification({
          title: L.localize('Label_SuccessEdit'),
          message: L.localize('Label_Success')
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaymentGateways.vue?01088906